// Central registry of the public marketing photography. To change a photo
// sitewide, drop the optimized files in public/images and update one entry
// here. Each photo ships as WebP (primary) with a JPEG fallback.

export const heroPhoto = {
  webp: '/images/hero.webp',
  jpg: '/images/hero.jpg',
  alt: 'AGSHK members holding the Ghanaian flag at a community gathering',
};

export const storyPhotos = [
  {
    webp: '/images/story-anniversary.webp',
    jpg: '/images/story-anniversary.jpg',
    title: '10th Anniversary Dinner',
    blurb: 'Marking ten years of AGSHK in Hong Kong.',
    alt: 'AGSHK members at the 10th anniversary dinner',
  },
  {
    webp: '/images/story-agm.webp',
    jpg: '/images/story-agm.jpg',
    title: 'Annual General Meeting',
    blurb: 'Members gather each year to shape how AGSHK is run.',
    alt: 'A member speaking at the AGSHK annual general meeting',
  },
  {
    webp: '/images/story-members.webp',
    jpg: '/images/story-members.jpg',
    title: 'AGSHK Members and Friends',
    blurb: 'Our members and friends, together in Hong Kong.',
    alt: 'AGSHK members and friends with the Ghanaian flag',
  },
];

export const photographyCredit = 'Event photography by Dr Lens';
